import Card from '@mui/material/Card';
import { Box } from '@mui/material';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import {
  useLocale,
  formatEventDate,
  formatEventTime,
  getImageUrl,
  Routes,
} from '@xolv-mybrightlink/common';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';
import { CmsEvent } from '../models/EventResult';
import { EventDetailRow } from './EventDetailRow';

type EventCardProps = {
  cmsEvent: CmsEvent;
};

export const EventCard = (props: EventCardProps) => {
  const locale = useLocale();
  const navigate = useNavigate();

  const onEventClicked = () => {
    navigate(
      Routes.resources.events.postId(props.cmsEvent.databaseId, 'all-events'),
    );
  };

  return (
    <Box
      onClick={onEventClicked}
      sx={{ width: 247, mr: 4, mb: 4, cursor: 'pointer' }}
    >
      <Card elevation={8} sx={{ height: '100%', width: 247, borderRadius: 3 }}>
        <Box
          sx={{
            position: 'relative',
          }}
        >
          <CardMedia
            component='img'
            src={getImageUrl(
              props?.cmsEvent?.featuredImage?.node?.mediaDetails?.sizes,
            )}
            alt='Event Image'
            sx={{ objectFit: 'cover', width: 247, height: 80 }}
          />
          <Box
            sx={{
              borderBottomRightRadius: 12,
              backgroundColor: '#626a7a',
              width: 50,
              height: 26,
              position: 'absolute',
              top: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              left: 0,
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                color: '#fff',
              }}
            >
              {props.cmsEvent.cost ?? (
                <FormattedMessage id='resources.event.free' />
              )}
            </Typography>
          </Box>
        </Box>
        <CardContent
          sx={{
            p: 2.5,
            justifyContent: 'space-between',
          }}
        >
          <Typography
            gutterBottom
            variant='body1'
            sx={{
              display: '-webkit-box',
              overflow: 'hidden',
              WebkitBoxOrient: 'vertical',
              fontWeight: 500,
              textOverflow: 'ellipsis',
              WebkitLineClamp: 2,
              height: 48,
            }}
          >
            {props.cmsEvent.title}
          </Typography>
          <EventDetailRow
            title={formatEventDate(
              props.cmsEvent.startDate,
              props.cmsEvent.endDate,
              locale,
            )}
            fontSize={14}
            titleSpacing={2.5}
            icon={
              <Box
                component='img'
                src='/public/assets/icons/ic_calendar.svg'
                alt='ic_calendar'
                sx={{ height: 16, width: 16 }}
              />
            }
          />
          <EventDetailRow
            title={formatEventTime(
              props.cmsEvent.startDate,
              props.cmsEvent.endDate,
            )}
            fontSize={14}
            titleSpacing={2.5}
            icon={
              <Box
                component='img'
                src='/public/assets/icons/ic_clock.svg'
                alt='ic_clock'
                sx={{ height: 16, width: 16 }}
              />
            }
          />
        </CardContent>
      </Card>
    </Box>
  );
};
